// extracted by mini-css-extract-plugin
export default {"tabSavedRowsContainer":"styles_tabSavedRowsContainer__5IiyO","buttonsContainer":"styles_buttonsContainer__2vT80","spinnerContainer":"styles_spinnerContainer__QQMzf"};